import { useTranslation } from "react-i18next";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useTargetingMutations from "../../datahooks/useTargetingMutations";

export default function ResetTargeting({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const { t } = useTranslation("campaigns");
  const isDesktop = useTwBreakpoint("lg");
  const { removeTargeting, isRemovingTargeting } = useTargetingMutations();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <Title>{t("targetingPreviewTitle")}</Title>
        <Description>{t("targetingPreviewSubtitle")}</Description>

        <div className="mt-8 flex justify-between gap-x-2.5">
          <Close asChild>
            <Button
              variant="outline-black"
              className="lg:flex-1"
              disabled={isRemovingTargeting}
            >
              Cancel
            </Button>
          </Close>

          <Button
            className="lg:flex-1"
            onClick={() => removeTargeting()}
            isLoading={isRemovingTargeting}
          >
            Yes
          </Button>
        </div>
      </Content>
    </Component>
  );
}
